import { inject, injectable } from '@servicetitan/react-ioc';
import { observable, makeObservable, action, computed } from 'mobx';

import {
    BrandSettingsResponseModel,
    BrandApi,
} from '@servicetitan/marketing-services-api/settings';
import { StandaloneRootStore } from '@servicetitan/standalone-root';

import { LoadStatus } from '../../../common/enums/load-status';

@injectable()
export class DefaultBrandStore {
    @observable data?: BrandSettingsResponseModel;
    @observable fetchDefaultBrandDataStatus = LoadStatus.None;

    @computed get defaultBrandId() {
        return this.standaloneRootStore.onboarding.defaultBrandId;
    }

    @computed get companyAddress() {
        if (this.data?.companyProperties) {
            const { street, city, state, zipCode } = this.data.companyProperties;
            return { street, city, state, zipCode };
        }
        return {};
    }

    constructor(
        @inject(BrandApi) private brandApi: BrandApi,
        @inject(StandaloneRootStore) private standaloneRootStore: StandaloneRootStore,
    ) {
        makeObservable(this);
    }

    async loadDefaultBrandData() {
        if (!this.defaultBrandId) {
            return;
        }
        this.setDefaultBrandDataFetchStatus(LoadStatus.Loading);
        try {
            const { data } = await this.brandApi.getBrandSettings({ brandId: this.defaultBrandId });
            this.setDefaultBrandData(data);
            this.setDefaultBrandDataFetchStatus(LoadStatus.Ok);
        } catch {
            this.setDefaultBrandDataFetchStatus(LoadStatus.Error);
        }
    }

    @action setDefaultBrandDataFetchStatus = (status: LoadStatus) =>
        (this.fetchDefaultBrandDataStatus = status);

    @action setDefaultBrandData = (data: BrandSettingsResponseModel) => (this.data = data);
}
